/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The ChildType component
 *
 * @author Thais Watanabe
 */
const ChildType = ({ type }) => {
  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 print:text-xxs print:px-1 print:py-0 print:max-h-3">
      {type}
    </span>
  );
};

export default ChildType;
